import React from 'react';
import PropTypes from 'prop-types';
import {
  WrapperCheckboxReverse,
  StyledCheckbox,
  StyledCheckableReverse,
  StyledIcon
} from './style';

import Label from '../Label';
import { Check } from '../../../../assets/images/index';

const CheckboxReverse = ({
  className,
  disabled,
  label,
  name,
  required,
  onChange,
  checked,
  id
}) => (
  <WrapperCheckboxReverse className={className}>
    <StyledCheckbox
      disabled={disabled}
      required={required}
      id={id}
      name={name}
      onChange={event => onChange(event.currentTarget.checked, event)}
      checked={checked}
    />
    <Label htmlFor={id} label={label} />
    <StyledCheckableReverse>
      <StyledIcon color="light" svg={Check} />
    </StyledCheckableReverse>
  </WrapperCheckboxReverse>
);

CheckboxReverse.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

CheckboxReverse.defaultProps = {
  required: false
};

export default CheckboxReverse;
